import { getApi ,postApi} from "./api_instance";

export const getSDG = async (logout) => {
    try {
      const response = await getApi({
        apiUrl: `/projects/api/sdg/demand/dashboard`,
        logout,
      });
      return response.data; 
    } catch (error) {
      throw error;
    }
  };

  export const updateHighestSDG= async (sdg,data_range, logout) => {
    try {
      const response = await postApi({
        apiUrl: `/admin/projects/api/sdg/demand/update`,
        data: {
          sdg,
          data_range
        },
        sendToken: true,
        logout,
      });
      return response.data; 
    } catch (error) {
      throw error;
    }
  };

export const getHighestAmountCredits = async (logout) => {
  try {
    const response = await getApi({
      apiUrl: `/projects/api/dashboard/top-credits/amount`,
      sendToken: true,
      logout,
    });
    return response.data; 
  } catch (error) {
    throw error;
  }
};


export const updateHighestAmountCredits = async (credits,data_range, logout) => {
  try {
    const response = await postApi({
      apiUrl: `/admin/projects/api/dashboard/top-credits/amount/update`,
      data: {
        credits,
        data_range
      },
      sendToken: true,
      logout,
    });
    return response.data; 
  } catch (error) {
    throw error;
  }
};

export const getTopCreditsInDemand = async (logout) => {
    try {
      const response = await getApi({
        apiUrl: `/projects/api/dashboard/top-credits/demand`,
        sendToken: true,
        logout,
      });
      return response.data; 
    } catch (error) {
      throw error;
    }
  };

  export const updateHighestDemand = async (credits,data_range, logout) => {
    try {
      const response = await postApi({
        apiUrl: `/admin/projects/api/dashboard/top-credits/demand/update`,
        data: {
          credits,
          data_range
        },
        sendToken: true,
        logout,
      });
      return response.data; 
    } catch (error) {
      throw error;
    }
  };